module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (129).e6b2fc4b.jpg";